// rentalRate constants
import OVERRIDE_RATE from '../constants/overrideRate.constant.rentalRate';

const getLowestRate = ({suggestedRate, threshold = OVERRIDE_RATE}) =>
  suggestedRate - threshold;

export default getLowestRate;
